import React, { ReactText, useState } from 'react';
import classNames from 'classnames';
import styles from './assets/case-calendar-screen.module.scss';
import { IStudent } from 'src/types/student';
import IntakeSentForm, { IntakeSentFormData } from './components/IntakeSentForm';
import InfoItem from '../../../../../../../../components/InfoItem';
import GeneralEnum from '../../../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../../../components/redux-form/utils/dropdown-values';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faEnvelope, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal } from 'react-bootstrap';
import { asyncPersistIntakeSent } from '../../../../../../../../store/actions/intakeSent-actions';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../../../../components/Loader';
import { DropZoneField } from '../../../../../../../../components/DropZoneField';

export interface StateProps {
    intakes: any;
    inProgress: boolean | null;
    inProgressIntakeSent: boolean | null;
}

export interface DispatchProps {
    uploadIntakes: (id: string | number | any, requestType: string, files: any, setLoad: any) => void;
    getIntakes: (id: string | number | any) => void;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export interface OwnProps {
    student: Partial<IStudent> | null;
    tab?: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const Intake: React.FunctionComponent<Props> = ({
    intakes,
    student,
    inProgress,
    inProgressIntakeSent,
    uploadIntakes,
}: Props) => {
    const IntakeType = GeneralEnum ? GeneralEnum.getEnum('IntakeType') : {};
    const intakeTypeValues: SelectObject[] = getValFromEnum(IntakeType);

    const [openedSend, setOpenedSend] = useState('');
    const [formFiles, setFormFiles] = useState({ file: null, intakeType: null });
    const [popup, setPopup] = useState('');
    const [opened, setOpened] = useState(false);
    const [load, setLoad] = useState(false);
    const handleClose = () => {
        setOpened(false);
        setOpenedSend('');
        setPopup('');
    };

    const dispatch = useDispatch();
    const studentId = student?.id;
    const stId: ReactText = studentId !== undefined ? studentId : '';

    const initData: IntakeSentFormData = {
        student: stId,
        isOne: false,
        intakes: {
            '1': false,
            '2': false,
            '3': false,
            '4': false,
            '5': false,
            '6': false,
            '7': false,
            '8': false,
            '9': false,
            '10': false,
            '11': false,
            '12': false,
            '13': false,
            '14': false,
            '17': false,
            '18': false,
            '19': false,
            '20': false,
            '21': false,
            '22': false,
            '23': false,
            '24': false,
        },
    };
    const handleAdd = (files: any, intakeType: any) => {
        setLoad(true);
        uploadIntakes(student?.id, intakeType, files, setLoad);
    };

    const onLoadFile = (itD: any, intakeType: any) => {
        setFormFiles({ file: itD, intakeType: intakeType });
        setPopup('56' + intakeType);
    };

    const previewIntakes = (data: any) =>
        data &&
        data.map((intake: any, i: number) => (
            <li key={`i${i}`} style={{ listStyleType: 'none' }}>
                {intake.attach ? (
                    <a rel="noopener noreferrer" target="_blank" href={`${intake.attach}`}>
                        <FontAwesomeIcon className={classNames(styles.addMarginRight)} icon={faDownload} />
                        {intakeTypeValues.find((it) => it.value == intake.intakeType)?.label} {' - '}
                        <b style={{ color: 'green' }}> completed</b>
                    </a>
                ) : (
                    <span>
                        {intakeTypeValues.find((it) => it.value == intake.intakeType)?.label} {' - '}
                        <b style={{ color: 'orange' }}> waiting</b>
                    </span>
                )}
                <button
                    type="button"
                    className="btn btn-success"
                    style={{ marginLeft: '20px', marginBottom: '10px' }}
                    title="Resend the form again"
                    onClick={() => setOpenedSend('10' + intake.intakeType)}
                >
                    <FontAwesomeIcon icon={faEnvelope} /> Resend
                </button>
                <Modal show={openedSend == '10' + intake.intakeType} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to reset the data of the form and send it to the parent again?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="danger"
                            onClick={() => {
                                handleClose();
                                asyncPersistIntakeSent(
                                    { ...initData, intakes: { [intake.intakeType]: true }, isOne: true },
                                    dispatch,
                                );
                            }}
                        >
                            Yes
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={popup == '56' + intake.intakeType} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to replace the current document with this one?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="danger"
                            onClick={() => {
                                handleClose();
                                if (formFiles.file && formFiles.intakeType) {
                                    handleAdd(formFiles.file, formFiles.intakeType);
                                }
                                setFormFiles({ file: null, intakeType: null });
                            }}
                        >
                            Yes
                        </Button>
                    </Modal.Footer>
                </Modal>

                <DropZoneField
                    single={true}
                    files={intake.attach ? intake : []}
                    setFiles={(itD: any) => onLoadFile(itD, intake.intakeType)}
                    //setFiles={(f: any) => handleAdd(f, intake.intakeType)}
                />
            </li>
        ));

    return (
        <div>
            <div className={classNames(styles.calendarWrap)}>
                <div className="">
                    {inProgressIntakeSent || inProgress || load ? <Loader /> : null}
                    {intakes?.length ? (
                        <div className={classNames(styles.infoWrap)}>
                            <div className={classNames(styles.infoWrap)}>
                                <div className={classNames(styles.infoItems)}>
                                    <InfoItem key={'index'} title={''} value={previewIntakes(intakes)} />
                                </div>
                            </div>
                            <button type="button" className="btn btn-secondary" onClick={() => setOpened(true)}>
                                <FontAwesomeIcon icon={faTrash} /> Clear all and resend again
                            </button>
                            <Modal show={opened} onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirmation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to clear all data and send the forms to the parent again?
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="danger"
                                        onClick={() => {
                                            handleClose();
                                            asyncPersistIntakeSent(initData, dispatch);
                                        }}
                                    >
                                        Yes
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    ) : (
                        <IntakeSentForm student={student} initialValues={initData} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Intake;
